import {
    BAR_CHART,
    CHANGES_IN_LAST_TWO_WEEKS_REPORT_TITLE,
    COST_BY_STATUS_REPORT_TITLE,
    COST_SUMMARY_REPORT_TITLE,
    DEVICES_BY_STATUS_REPORT_TITLE,
    LINE_CHART,
    PIE_CHART,
    TOTAL_DEVICES_REPORT_TITLE
} from "constants/reports_constants";
import ChartGenerator from "reports/charts/chart_generator"
import CostByStatusReportGenerator from "reports/library/cost_by_status_report_generator";
import CostSummaryReportGenerator from "reports/library/cost_summary_report_generator";
import ChangesInLastTwoWeeksReportGenerator from "reports/library/changes_in_last_two_weeks_report_generator";
import DevicesByStatusReportGenerator from "reports/library/devices_by_status_report_generator";
import TotalDevicesReportGenerator from "reports/library/total_devices_report_generator";
import {
    costByByStatusLabelReducer,
    deploymentStatusLabelReducer,
    deviceTypeLabelReducer,
    updatedAtLabelReducer
} from "reports/charts/data_factories/label_reducer_functions";
import {
    deploymentStatusLabel,
    deviceCostLabel,
    deviceTypeLabel,
    updatedAtLabel
} from "reports/charts/data_factories/label_function";
import { counterValue, deviceCostValue } from "reports/charts/data_factories/value_function";
import NoChartGenerator from "reports/charts/no_chart_generator";

let get_chart_element = function (event) {
    const chart = Chartkick.charts['chart-1'].getChartObject().delay(500);
    const element = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);
    if (element) {
        $.ajax('find_report', {
            type: 'GET', dataType: 'script', data: {
                item: chart.data.labels[element[0].index],
                value: chart.data.datasets[element[0].datasetIndex].data[element[0].index],
                report_type: $("input[name='report_button']:checked").val(),
                location_id: $('#report_loc_select').val(),
                controller: $('#controller').val()
            }, success: function () {
                $('#report_spinner').hide()
                // Table is already initialized by items_table_controller.js
                // No need to call bootstrapTable() again
            }, error: function (jqXHR, textStatus, errorThrown) {
                $('#report_spinner').hide()
                return console.log("AJAX Error: " + textStatus);
            }
        });
    }
};

// $(document).on('change', "input[name='report_button']", select_report);
// $(document).on('change', "#report_loc_select", report_location);
// $(document).on('click', 'canvas', get_chart_element);

export function getReportGenerator(reportTitle) {
    // report spinner shows BS div, hidden when report object is returned in report_generator using hideReportSpinner()
    $('#report_spinner').attr('style', 'display:block')
    switch (reportTitle) {
        case COST_BY_STATUS_REPORT_TITLE:
            return new CostByStatusReportGenerator();
        case COST_SUMMARY_REPORT_TITLE:
            return new CostSummaryReportGenerator();
        case CHANGES_IN_LAST_TWO_WEEKS_REPORT_TITLE:
            return new ChangesInLastTwoWeeksReportGenerator();
        case DEVICES_BY_STATUS_REPORT_TITLE:
            return new DevicesByStatusReportGenerator();
        case TOTAL_DEVICES_REPORT_TITLE:
            return new TotalDevicesReportGenerator();
        default:
            throw new Error(`Unknown report type: [${ reportTitle }]`);
    }
}

export function hideReportSpinner() {
    $('#report_spinner').attr('style', 'display:none')
}

export function getChartGenerator(reportTitle, filterFunction = null) {
    switch (reportTitle) {
        case COST_BY_STATUS_REPORT_TITLE:
            return new ChartGenerator(BAR_CHART, deviceCostLabel, costByByStatusLabelReducer, deviceCostValue, filterFunction);
        case COST_SUMMARY_REPORT_TITLE:
            return new NoChartGenerator();
        case CHANGES_IN_LAST_TWO_WEEKS_REPORT_TITLE:
            return new ChartGenerator(LINE_CHART, updatedAtLabel, updatedAtLabelReducer, counterValue, filterFunction);
        case DEVICES_BY_STATUS_REPORT_TITLE:
            return new ChartGenerator(PIE_CHART, deploymentStatusLabel, deploymentStatusLabelReducer, counterValue, filterFunction);
        case TOTAL_DEVICES_REPORT_TITLE:
            return new ChartGenerator(BAR_CHART, deviceTypeLabel, deviceTypeLabelReducer, counterValue, filterFunction)
        default:
            throw new Error(`Unknown report type: [${ reportTitle }]`);
    }
}

let initializeTable = function () {
    // NOTE: Table initialization is now handled by items_table_controller.js
    // This function is kept for backwards compatibility but does nothing
    // The controller handles all bootstrap-table configuration including:
    // - Column definitions
    // - Pagination
    // - Search
    // - Export
    // - Detail view (for bundle instances)

    // Only set up the export confirmation dialog
    $('[aria-label="Export data"]').on("click", function (event) {
        return confirm('Large exports take time to generate and may slow browser for extended period. Continue?');
    })
}

// DISABLED: Table initialization is now handled by items_table_controller.js (Stimulus)
// This turbolinks:load handler was causing double initialization
// $(document).on('turbolinks:load', initializeTable);